export const getConversationTitle = (metaConversation) => {
    const { requester } = metaConversation;
    const { id: csid, initial_channel: initialChannel, attributes, is_abandoned: isAbandoned, } = metaConversation.conversation;
    const requesterInfo = requester
        ? requester.name ||
            requester.email ||
            requester.phone_number ||
            (requester.anonymized_at ? 'Anonymized user' : '')
        : `#${csid}`;
    const subject = initialChannel === 'email' || initialChannel === 'contactform'
        ? (attributes === null || attributes === void 0 ? void 0 : attributes.subject) || ''
        : '';
    return {
        requester: `${isAbandoned ? 'Abandoned: ' : ''}${requesterInfo}`,
        subject,
    };
};
